import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const getAuth = () => firebase.auth();

export { getAuth };
